import { FieldProps, getIn } from 'formik';
import { FocusEvent, useCallback } from 'react';
import { TextInput } from '../inputs/TextInput';

export type FieldCompareStatus = 'none' | 'matched' | 'mismatched';
interface ITextInputFieldProps extends FieldProps {
  id?: string;
  required?: boolean;
  highlightFullBorder?: boolean;
  compareStatus?: FieldCompareStatus;
}

export const TextInputField = ({ form, field, required, highlightFullBorder, compareStatus, ...props } : ITextInputFieldProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const handleBlur = useCallback(
      (event: FocusEvent<HTMLInputElement>) => {
        const { value } = event.target;
        if (value) {
          const trimmedValue = value.trim();

          form.setFieldValue(field.name, trimmedValue);

          field.onBlur({
            ...event,
            target: {
              name: field.name,
              value: trimmedValue,
            },
          });
        }
      },
      [field, form],
  );

  return (
      <TextInput
          {...field}
          {...props}
          id={props.id || field.name}
          required={!!required}
          error={touched && !!error}
          highlightFullBorder={!!error && highlightFullBorder}
          helperText={(touched && error) || ''}
          sx={{
            '& .MuiInputBase-input': {
              backgroundColor:
                compareStatus === 'mismatched'
                  ? 'error.light'
                  : compareStatus === 'matched'
                  ? 'success.light'
                  : 'grey.100',
            },
          }}
          onBlur={handleBlur}
      />
  );
};
